import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'btn-delete-row-renderer',
  template: `
    <button
      class="btn btn-sm btn-danger"
      (click)="onClick($event)"
      title="Delete Row"
    >
      <i class="fas fa-trash"></i>
    </button>
  `,
  styles: [`
    button {
      cursor: pointer;
      padding: 2px 8px;
    }
  `]
})
export class BtnDeleteRowRendererComponent implements ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  onClick($event: any): void {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        rowIndex: this.params.node.rowIndex
      };
      this.params.onClick(params);
    }
  }

  refresh(): boolean {
    return false;
  }
}
